import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { QineticNegotiationApi } from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const selectOffer = createAsyncThunk<string, string, ThunkApi>(
  "selectOffer",
  async (offerId, { rejectWithValue }) => {
    try {
      await new QineticNegotiationApi().preConfirmOffer(offerId);

      return offerId;
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Selezione offerta",
        description:
          "Non siamo riusciti a selezionare un'altra offerta.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
